import { NotizMitarbeiterResponse } from '@/types/service-response'

export class ProductNoteEmployee {
  public constructor (
    readonly id: number,
    readonly lastName: string,
    readonly firtName: string,
    readonly fullName: string,
    readonly shortName: string,
  ) {}

  static createFromResponse (responseData: NotizMitarbeiterResponse[]): Array<ProductNoteEmployee> {
    let result: Array<ProductNoteEmployee> = []
    if (responseData) {
      result = responseData.map((item: NotizMitarbeiterResponse ) => {
        return new ProductNoteEmployee(
          item.ID,
          item.Name ? item.Name : '',
          item.Vorname ? item.Vorname : '',
          item.VollerName ? item.VollerName : '',
          item.Kurzzeichen ? item.Kurzzeichen : '',
        )
      })
    }
    return result
  }
}
